import { Component, HostListener, inject, ViewEncapsulation } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { TourService } from './tour.service';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-tour-popover',
  encapsulation: ViewEncapsulation.Emulated,
  imports: [AsyncPipe, NgClass, MatCardModule, MatButtonModule, MatIconModule],
  animations: [],
  templateUrl: './tour-popover.component.html',
  styleUrls: ['./tour-popover.component.scss'],
})
export class TourPopoverComponent {
  service = inject(TourService);

  @HostListener('document:keydown', ['$event'])
  onKey = async (e: KeyboardEvent) => {
    switch (e.key) {
      case 'Escape':
        await this.service.requestExitViaCloseButton();
        break;
      case 'ArrowLeft':
        await this.service.prev();
        break;
      case 'ArrowRight':
        await this.service.next();
        break;
    }
  };
}
